import React, { useEffect } from "react";
import PageWrapper from '../layouts/Index';
import PageTitle from '../components/PageTitle';
import { Form, Formik } from "formik";
import CustomSelectField from "../components/CustomSelectField";
import CustomInputField from "../components/CustomInputField";
import { useNavigate } from "react-router-dom";
import { oxygenRetailSchema } from "../utils/formValidationSchema";
import { useDispatch, useSelector } from "react-redux";
import { getAllBanks, getEmploymentStatus, setCustomermsisdn } from "../redux/features/oxygen/oxygenRetailSlice";
import useCustomAlert from "../components/Alert2";
import { submitCustomerDetails } from "../services/oxygenRetailServices";
import {setPreCustomerId} from "../redux/features/oxygen/oxygenRetailSlice";
import { updatePrecustomer } from "../redux/features/precustomers/PrecustomerSlice";
import {getFinancier} from "../redux/features/oxygen/oxygenRetailSlice";

const OxygenDetailsUpdate = () => {
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const customAlert = useCustomAlert();
    const loggedInUser = useSelector((state) => state?.user?.user);
    const financier = useSelector((state) => state.oxygenRetail?.financiers);
    const oxygenFinancier = financier?.filter(item => Number(item.id) === 14 || Number(item.partnerId) === 408) || [];
    const allBanks = useSelector((state) => state.oxygenRetail?.allBanks) || [];
    // const employmentStatus = useSelector((state) => state.oxygenRetail?.employmentStatus) || [];
    const storePrecustomer = useSelector((state) => state?.precustomer?.precustomerData?.precustomer);

    useEffect(() => {
    dispatch(getAllBanks());
    dispatch(getEmploymentStatus());
    dispatch(getFinancier());
    }, [dispatch]);
    
    const employData = [
    { name: "SELF_EMPLOYED", id: "1" },
    { name: "UNEMPLOYED", id: "2" },
    { name: "EMPLOYED", id: "3" },
    ]

    localStorage.setItem("allAboard-financierid", JSON.stringify(oxygenFinancier[0]?.id));
    localStorage.setItem("financierName", JSON.stringify(oxygenFinancier[0]?.name));
    localStorage.setItem("allAboard-partnerid", JSON.stringify(oxygenFinancier[0]?.partnerId));
  
    const initialValues = {
      bank: storePrecustomer?.bankName || "", 
      accountNumber: storePrecustomer?.accountNumber || "",
    //   accountName: storePrecustomer?.accountName || "",
      email:storePrecustomer?.email || "",
      bvn:storePrecustomer?.bvn || "",
      nin: storePrecustomer?.nin || "",
      msisdn:storePrecustomer?.msisdn || "",
      employmentStatus: storePrecustomer?.employmentStatus || "",
      nameOfEmployer: storePrecustomer?.employerName || "",
      salaryAmount: storePrecustomer?.salaryAmount || "",
      salaryDay: storePrecustomer?.salaryDate || "",
    };

    const handleSubmit = async (values) => {
    const formData = {
        msisdn: String(values.msisdn),
        email: values.email,
        bvn: String(values.bvn),
        nin: String(values.nin),
        bankCode: allBanks?.data?.find((bank) => bank.name === values.bank)?.sortCode, 
        bankName: values.bank,
        accountNumber: String(values.accountNumber),
        // accountName: values.accountName,
        employmentStatus: values.employmentStatus,
        nameOfEmployer: values.nameOfEmployer,
        salaryAmount: String(values.salaryAmount),
        salaryDate: Number(values.salaryDay) || 0,
        is_Self_Onboard: false,
        repId: Number(loggedInUser?.id),
        is_Modified: true,
    };

    const res = await submitCustomerDetails(formData);

    if(res.status === true) {
        dispatch(setCustomermsisdn(res.data));
        dispatch(setPreCustomerId(res.preCustomerId));
        dispatch(updatePrecustomer({
            precustomer:{
                precustomerId:res?.preCustomerId,
                msisdn:res?.data?.msisdn,
                nin: formData?.nin,
                bvn: formData?.bvn,
                accountNumber: formData?.accountNumber,
                email: formData?.email,
                bankName : formData?.bankName,
                employmentStatus : formData?.employmentStatus,
                employerName : formData?.nameOfEmployer,
                salaryAmount : formData?.salaryAmount,
                salaryDate : formData?.salaryDate
            },
            onboarding_status: "validate-otp-oxygen",
        }));
        customAlert.showToast("success", `Customer details submitted successfully, ${res?.message}`); 
        navigate("/oxygenForm-OTP"); 
        
    } else {
        customAlert.showToast("error", `${res?.message}` || "Failed to submit customer details");
    }
    };

  return (
    <PageWrapper>
        <PageTitle title="Prequalification: RETAIL"/>
        <div className="row">
            <div className="col-xl-6 col-lg-8 col-md-12">
                <div className="card">
                <div className="card-header">
                    <h4 className="card-title">Oxygen Customer</h4>
                </div>
                <div className="card-body">
                    <Formik
                    initialValues={initialValues}
                    validationSchema={oxygenRetailSchema}
                    onSubmit={(values) => handleSubmit(values)}
                    >
                    {({
                        errors,
                        touched,
                        values,
                        handleBlur,
                        handleChange,
                        isSubmitting,
                        setFieldValue,
                        handleSubmit,
                    }) =>{
                        const isUnemployed = values.employmentStatus === "UNEMPLOYED";
                        const isSelfEmployed = values.employmentStatus === "SELF_EMPLOYED";
                        const isEmployed = values.employmentStatus === "EMPLOYED";
        
                        return(
                        <Form>
                        <div className="row mb-2">
                            <div className="col-sm-12">
                            <CustomSelectField
                                label="Bank"
                                placeholder="Select Bank"
                                name="bank"
                                onChange={handleChange}
                                value={values.bank || ""} 
                                onBlur={handleBlur}
                                error={errors.bank}
                                touched={touched.bank}
                            >
                                {allBanks?.data?.map((item) => (
                                <option key={item.code} value={item.name}>
                                    {item.name}
                                </option>
                                ))}
                            </CustomSelectField>
                            </div>
                        </div>
        
                        <div className="row mb-2">
                            <div className="col-md-6 col-sm-12">
                            <CustomInputField
                                label="Account Number"
                                placeholder="Enter Account Number"
                                name="accountNumber"
                                value={values.accountNumber}
                                onChange={handleChange}
                                onBlur={handleBlur}
                                error={errors.accountNumber}
                                touched={touched.accountNumber}
                            />
                            </div>
                            <div className="col-md-6 col-sm-12">
                            <CustomInputField
                                label="NIN"
                                placeholder="Enter Your NIN"
                                name="nin"
                                type="number"
                                value={values.nin}
                                onChange={handleChange}
                                onBlur={handleBlur}
                                error={errors.nin}
                                touched={touched.nin}
                                readOnly={true }
                            />
                            </div>
                            
                        </div>
                        <div className="row mb-2">
                            <div className="col-sm-12">
                                <CustomInputField
                                label="BVN"
                                placeholder="Enter Your BVN"
                                name="bvn"
                                type="number"
                                value={values.bvn}
                                onChange={handleChange}
                                onBlur={handleBlur}
                                error={errors.bvn}
                                touched={touched.bvn}
                                />
                            </div>
                        </div>
        
                        {/* <div className="row mb-2">
                            <div className="col-md-6 col-sm-12">
                            <CustomInputField
                                label="Account Name"
                                placeholder="Enter Account Name"
                                name="accountName"
                                value={values.accountName}
                                onChange={handleChange}
                                onBlur={handleBlur}
                                error={errors.accountName}
                                touched={touched.accountName}
                                readOnly={true}
                            />
                            </div>
                            <div className="col-md-6 col-sm-12">
                            <CustomInputField
                                label="BVN"
                                placeholder="Enter Your BVN"
                                name="bvn"
                                type="number"
                                value={values.bvn}
                                onChange={handleChange}
                                onBlur={handleBlur}
                                error={errors.bvn}
                                touched={touched.bvn}
                                readOnly={true}
                            />
                            </div>
                        </div> */}
        
                        <div className="row mb-2">
                            <div className="col-md-6 col-sm-12">
                            <CustomInputField
                                label="Email Address"
                                placeholder="Enter Your Email Address"
                                name="email"
                                type="email"
                                value={values.email}
                                onChange={handleChange}
                                onBlur={handleBlur}
                                error={errors.email}
                                touched={touched.email}
                                readOnly={ true}
                            />
                            </div>
                            <div className="col-md-6 col-sm-12">
                            <CustomInputField
                                label="Phone Number"
                                placeholder="Enter phone number"
                                name="msisdn"
                                type="tel"
                                value={values.msisdn}
                                onChange={handleChange}
                                onBlur={handleBlur}
                                error={errors.msisdn}
                                touched={touched.msisdn}
                                readOnly={true}
                            />
                            </div>
                        </div>
        
                        <div className="row mb-2">
                            <div className="col-md-6 col-sm-12">
                            <CustomSelectField
                                label="Employment Status"
                                placeholder="Select Status"
                                name="employmentStatus"
                                onChange={handleChange}
                                value={values.employmentStatus}
                                onBlur={handleBlur}
                                error={errors.employmentStatus}
                                touched={touched.employmentStatus}
                                disabled={true}
                            >
                                {/* {employmentStatus?.data?.map((item) => (
                                <option key={item.id} value={item.name}>
                                    {item.name}
                                </option>
                                ))} */}
                                {employData?.map((item) => (
                                <option key={item.id} value={item.name}>
                                    {item.name}
                                </option>
                                ))}
                            </CustomSelectField>
                            </div>
                            <div className="col-md-6 col-sm-12">
                            <CustomInputField
                                label="Name of Employer"
                                placeholder="Enter Name of Employer"
                                name="nameOfEmployer"
                                value={values.nameOfEmployer}
                                onChange={handleChange}
                                onBlur={handleBlur}
                                error={errors.nameOfEmployer}
                                touched={touched.nameOfEmployer}
                                readOnly={isUnemployed ? true : true}
                                required={isEmployed ? true : false}
                            />
                            </div>
                        </div>
        
                        <div className="row mb-2">
                            <div className="col-md-6 col-sm-12">
                            <CustomInputField
                                label="Salary Amount"
                                placeholder="Enter Salary Amount"
                                name="salaryAmount"
                                type="number"
                                value={values.salaryAmount}
                                onChange={handleChange}
                                onBlur={handleBlur}
                                error={errors.salaryAmount}
                                touched={touched.salaryAmount}
                                readOnly={isUnemployed ? true : isSelfEmployed ? true : true}
                                required={isEmployed? true : false}
                            />
                            </div>
                            <div className="col-md-6 col-sm-12">
                            <CustomInputField
                                label="Salary Date (e.g 29)"
                                placeholder="Enter Salary Day"
                                name="salaryDay"
                                type="number"
                                value={values.salaryDay}
                                onChange={handleChange}
                                onBlur={handleBlur}
                                error={errors.salaryDay}
                                touched={touched.salaryDay}
                                readOnly={isUnemployed ? true : isSelfEmployed ? true : true}
                                required={isEmployed ? true : false}
                            />
                            </div>
                        </div>
        
                        <button
                            type="submit"
                            className="btn btn-primary btn-lg"
                            disabled={isSubmitting}
                        >
                            {isSubmitting ? "Please wait..." : "Submit"}
                        </button>
                        </Form>
                    )}
                    }
                    </Formik>
                </div>
                </div>
            </div>
        </div>
    </PageWrapper>
  )
}

export default OxygenDetailsUpdate;